import { Route } from "@angular/router";
import { authGuard } from "@core/auth/guards/auth.guard";
import { ForbiddenUserComponent } from "@shared/components/forbidden-user/forbidden-user.component";
import { NaturalPersonOrNoProfileFoundComponent } from "@shared/components/natural-person-or-no-profile-found/natural-person-or-no-profile-found.component";
import { employerRedirectGuard } from "@shared/guards/empleadorRedirect.guard";
import { reservaGuard } from "@shared/guards/reserva.guard";
import { initialDataResolver } from "app/app.resolvers";
import { LayoutComponent } from "app/layout/layout.component";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  // Redirect empty path to '/example'
  {
    path: "",
    pathMatch: "full",
    redirectTo: "banner",
  },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  {
    path: "signed-in-redirect",
    pathMatch: "full",
    redirectTo: "apl-afiliacion-onboarding",
  },

  // Auth routes for authenticated users
  // {
  //     path: '',
  //     // canMatch: [authGuard],
  //     component: LayoutComponent,
  //     data: {
  //         layout: 'empty'
  //     },
  //     children: [
  //         {
  //             path: 'sign-out',
  //             loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)
  //         },
  //         {
  //             path: 'unlock-session',
  //             loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule)
  //         }
  //     ]
  // },

  // Landing routes
  {
    path: "",
    canMatch: [],
    component: LayoutComponent,
    data: {
      layout: "modern",
    },
    children: [
      {
        path: "firma-formulario-afiliacion",
        loadChildren: () =>
          import(
            "app/modules/afiliacion/firma-formulario-afiliacion/firma-formulario-afiliacion.module"
          ).then((m) => m.FirmaFormularioAfiliacionModule),
        canDeactivate: [reservaGuard],
      },
    ],
  },
  {
    path: "",
    canMatch: [],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "banner",
        loadChildren: () =>
          import("app/modules/landing/Provisional-banner/banner.module").then(
            (m) => m.BannerModule
          ),
      },
    ],
  },

  {
    path: "home/apl-afiliacion-onboarding",
    canDeactivate: [reservaGuard],
    children: [
      {
        path: 'consultar/:token',
        loadChildren: () =>
          import(
            'app/modules/apl-afiliacion/apl-afiliacion-onboarding/apl-afiliacion-onboarding.module'
          ).then((m) => m.AplAfiliacionOnboardingModule),

      },
      {
        path: "",
        component: LayoutComponent,
        data: {
          layout: "modern",
        },
        resolve: {
          initialData: initialDataResolver,
        },
        children: [
          {
            path: 'pagos',
            loadChildren: () =>
              import(
                'app/modules/apl-afiliacion/ael-afiliacion-pagos/ael-afiliacion-pagos.module'
              ).then((m) => m.AplAfiliacionPagosModule),
          },
        ]
      },
      {
        path: "",
        component: LayoutComponent,
        data: {
          layout: "modern",
        },
        resolve: {
          initialData: initialDataResolver,
        },
        children: [
          {
            path: 'bases-referencia',
            loadChildren: () =>
              import(
                'app/modules/apl-afiliacion/ael-afiliacion-reportes/ael-afiliacion-reportes.module'
              ).then((m) => m.AelAfiliacionReportesModule),
          },
        ]
      }
    ]
  },
    {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "no-profile-found",
        component: NaturalPersonOrNoProfileFoundComponent,
      },
    ],
  },

   {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "forbidden-user",
        component: ForbiddenUserComponent,
      },
    ],
  },
  // Focun routes
  {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "modern",
    },
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: "home",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import("app/modules/landing/home.module").then(
            (m) => m.LandingHomeModule
          ),
      },
      {
        path: "afiliacion",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import("app/modules/afiliacion/afiliacion.module").then(
            (m) => m.AfiliacionModule
          ),
        canDeactivate: [reservaGuard]
      },
      {
        path: "afiliacion-individual",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import(
            "app/modules/afiliacion/afiliacion-individual/afiliacion-individual.module"
          ).then((m) => m.AfiliacionIndividualModule),
        canDeactivate: [reservaGuard],
      },
      {
        path: "control-afiliacion",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import(
            "app/modules/afiliacion/control-afiliacion/control-afiliacion.module"
          ).then((m) => m.ControlAfiliacionModule),
        canDeactivate: [reservaGuard],
      },
      {
        path: "afiliacion-home",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import(
            "app/modules/afiliacion/home-afiliacion/home-afiliacion.module"
          ).then((m) => m.HomeAfiliacionModule),
        canDeactivate: [reservaGuard],
      },
      {
        path: "ans",
        canMatch: [authGuard],
        loadChildren: () =>
          import("app/modules/ans/ans.module").then((m) => m.AnsModule),
        canDeactivate: [reservaGuard],
      },
      {
        path: "historial-afiliaciones",
        canMatch: [authGuard],
        canActivate: [employerRedirectGuard],
        loadChildren: () =>
          import(
            "app/modules/afiliacion/historial-afiliaciones/historial-afiliaciones.module"
          ).then((m) => m.HistorialAfiliacionesModule),
        canDeactivate: [reservaGuard],
      },
      // {
      //     path: 'informes',
      //     canMatch: [authGuard],
      //     loadChildren: () => import('app/modules/informes/informes.module').then(m => m.InformesModule)
      // }
    ],
  },
];
